<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      @reload="getData()"
    />
  </div>
</template>
<script>
import PageMain from './main'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain },
  mixins: [EditLoading],
  props: { evgPurchaseBatchCode: { type: String, default: '' } },
  data() {
    return { tableData: [], loading: false }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.evgPurchaseBatchCode) return
      this.loading = true
      const params = { evgPurchaseBatchCode: this.evgPurchaseBatchCode }
      const res = await this.$api
        .ecomEvgPurchaseBatchSkuListApi(params)
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
  },
}
</script>
